import React from 'react';
import { Grid } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import ExpenseCodeChips from './ExpenseCodeChips';

export const TimeAndExpenseCardContent = ({ editable, projectPermissions }) => (
  <Grid container spacing={2}>
    {projectPermissions.canViewExpenseCodes && (
      <Grid item xs={12}>
        <ExpenseCodeChips
          editable={editable && projectPermissions.canEditExpenseCodes}
        />
      </Grid>
    )}
  </Grid>
);

TimeAndExpenseCardContent.propTypes = {
  editable: PropTypes.bool,
  projectPermissions: PropTypes.object
};

export default TimeAndExpenseCardContent;
